<template>
  <div class="cmp-checkoutmercadopago" v-if="checkoutId">
    <checkout :key="checkoutId"></checkout>
  </div>
</template>

<script>
import Checkout from "./components/Checkout";
// Detect if library loaded
function isLoadedScript(lib) {
  return document.querySelectorAll('[src="' + lib + '"]').length > 0;
}
// Load library
function loadScript(lib) {
  var script = document.createElement("script");
  script.setAttribute("src", lib);
  document.getElementsByTagName("head")[0].appendChild(script);
  return script;
}
export default {
  name: "App",
  data(){
    return {
      checkoutId: false
    }
  },
  props: {
    mode:{
      type:String,
      default:'complete'
    },
    singleQuote:{
      type:Boolean,
      default:false
    },
    formLabels:{
      type: Object,
      default: function(){
        return {}
      }
    },
    publicKey:{
      type:String,
      default:'TEST-5ea2c45c-924f-47c7-abc1-cdbb82ff1539'
    },
    business: {
      type: Object,
      default: function(){
        return {
          logo: "https://www.komarcalabs.com/images/komarcaLogo.png",
          name: "Komarca Labs"
        }
      }
    },
    buyer: {
      type: Object,
      default: function(){
        return {
          email: "h.talledo28@gmail.com",
          name: "Humberto Talledo",
          documentType: "DNI",
          documentNumber: "46480370"
        }
      }
    },
    purchase: {
      type: Object,
      default: function(){
        return {
          amount: 100,
          description: "test producto",
          preorderId: "preorder-id-123456"
        }
      }
    },
  },
  provide: function() {
      return {
        mode:this.mode,
        singleQuote:this.singleQuote,
        publicKey:this.publicKey,
        business: this.business,
        buyer: this.buyer,
        purchase: this.purchase,
        formLabels:this.formLabels
      };
  },
  beforeCreate() {
    var lib = "https://secure.mlstatic.com/sdk/javascript/v1/mercadopago.js";
    if (!isLoadedScript(lib)) {
      loadScript(lib);
    }
  },
  created() {
    this.checkoutId='_' + Math.random().toString(36).substr(2, 9);
  },
  components: {
    Checkout,
  },
};
</script>

<style lang="scss">
.cmp-checkoutmercadopago {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0 auto;
}
</style>
